import ExecAPI from 'appRoot/api/api';

/**
 * Gets the status of the Ip2Location database update thread.
 */
export function GetIp2LocationDbUpdateStatus()
{
	return ExecAPI("AdminMisc/GetIp2LocationDbUpdateStatus");
}
/**
 * Manually triggers an update of the Ip2Location database.
 */
export function ManuallyTriggerIp2LocationDbUpdate()
{
	return ExecAPI("AdminMisc/ManuallyTriggerIp2LocationDbUpdate");
}